module.exports = __webpack_public_path__ + "static/media/rocket-icon-png-6.515ae87a.png";